import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import { useEffect, useRef, useState } from 'react';

interface IProps {
  expiredTime: number;
  onEnd?: () => void;
}
type Fnc = () => void;
const noop = () => {};
dayjs.extend(duration);

const useCountDown = (props: Partial<IProps>) => {
  const { expiredTime, onEnd } = props;
  const currentTime = dayjs().valueOf();
  let diffTime = dayjs(expiredTime ?? 0).diff(currentTime);
  const [time, setTime] = useState(diffTime);
  const tickRef = useRef<Fnc>(noop);
  let timerId: any;
  const closeStatus = useRef(false);
  const onClear = () => {
    clearInterval(timerId);
    if (!closeStatus.current) {
      closeStatus.current = true;
      onEnd?.();
    }
  };

  const tick = () => {
    if (diffTime > 0) {
      setTime(time - 1000);
    } else {
      onClear();
    }
  };

  useEffect(() => {
    tickRef.current = tick;
  });

  useEffect(() => {
    timerId = setInterval(() => tickRef.current(), 1000);
    return () => onClear();
  }, []);

  // 将秒转成时分秒
  const convertSecToHHmmss = () => {
    if (isNaN(diffTime) || diffTime <= 0) {
      return '00:00:00';
    }

    // return `${Math.floor(diffTime1 / 3600)}时：${Math.floor((diffTime1 % 3600) / 60)}分：${diffTime1 % 3600 % 60}`;
    return dayjs
      .duration(diffTime)
      .format(diffTime > 86400000 ? 'DD天 HH:mm:ss' : 'HH:mm:ss');
  };

  return [convertSecToHHmmss];
};

export default useCountDown;
